/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GiustificativiAllegatiRequestDTO,
  GiustificativiAllegatiResponseDTO,
  GiustificativiResponseDTO,
  GiustificativiUploadAllegatiDTO,
  GiustificativiUploadArchivioDTO,
  ProblemDetails,
} from '../models/index';
import {
    GiustificativiAllegatiRequestDTOFromJSON,
    GiustificativiAllegatiRequestDTOToJSON,
    GiustificativiAllegatiResponseDTOFromJSON,
    GiustificativiAllegatiResponseDTOToJSON,
    GiustificativiResponseDTOFromJSON,
    GiustificativiResponseDTOToJSON,
    GiustificativiUploadAllegatiDTOFromJSON,
    GiustificativiUploadAllegatiDTOToJSON,
    GiustificativiUploadArchivioDTOFromJSON,
    GiustificativiUploadArchivioDTOToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface GetAllegatiByGiustificativoRequest {
    giustificativiAllegatiRequestDTO?: GiustificativiAllegatiRequestDTO;
}

export interface GetGiustificativiRequest {
    mese?: Date;
    hasAllegati?: boolean;
}

export interface UploadAllegatiRequest {
    files?: Array<Blob>;
    rimborsi?: Array<GiustificativiUploadAllegatiDTO>;
}

export interface UploadAllegatiArchivioRequest {
    giustificativiUploadArchivioDTO?: GiustificativiUploadArchivioDTO;
}

/**
 * 
 */
export class GiustificativiApi extends runtime.BaseAPI {

    /**
     */
    async getAllegatiByGiustificativoRaw(requestParameters: GetAllegatiByGiustificativoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GiustificativiAllegatiResponseDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Giustificativi/GetAllegatiByGiustificativo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GiustificativiAllegatiRequestDTOToJSON(requestParameters['giustificativiAllegatiRequestDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GiustificativiAllegatiResponseDTOFromJSON));
    }

    /**
     */
    async getAllegatiByGiustificativo(requestParameters: GetAllegatiByGiustificativoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GiustificativiAllegatiResponseDTO>> {
        const response = await this.getAllegatiByGiustificativoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getGiustificativiRaw(requestParameters: GetGiustificativiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GiustificativiResponseDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['mese'] != null) {
            queryParameters['mese'] = (requestParameters['mese'] as any).toISOString();
        }

        if (requestParameters['hasAllegati'] != null) {
            queryParameters['hasAllegati'] = requestParameters['hasAllegati'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Giustificativi`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GiustificativiResponseDTOFromJSON));
    }

    /**
     */
    async getGiustificativi(requestParameters: GetGiustificativiRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GiustificativiResponseDTO>> {
        const response = await this.getGiustificativiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadAllegatiRaw(requestParameters: UploadAllegatiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['files'] != null) {
            requestParameters['files'].forEach((element) => {
                formParams.append('files', element as any);
            })
        }

        if (requestParameters['rimborsi'] != null) {
            requestParameters['rimborsi'].forEach((element) => {
                formParams.append('rimborsi', element as any);
            })
        }

        const response = await this.request({
            path: `/api/Giustificativi/uploadAllegati`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async uploadAllegati(requestParameters: UploadAllegatiRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uploadAllegatiRaw(requestParameters, initOverrides);
    }

    /**
     */
    async uploadAllegatiArchivioRaw(requestParameters: UploadAllegatiArchivioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Giustificativi/uploadAllegatiArchivio`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GiustificativiUploadArchivioDTOToJSON(requestParameters['giustificativiUploadArchivioDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async uploadAllegatiArchivio(requestParameters: UploadAllegatiArchivioRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uploadAllegatiArchivioRaw(requestParameters, initOverrides);
    }

}
